<template>
    <a-modal v-model:visible="visible" :width="325" wrapClassName="phone-modal" :maskClosable="false" :centered="true"
        destroyOnClose title="修改手机号" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
        <a-form :rules="rules" ref="formRef" :model="formState">
            <a-form-item name="mobile" class="ipt">
                <a-input v-model:value="formState.mobile" placeholder="请输入新手机号" style="height: 46px;"> </a-input>
            </a-form-item>
            <!-- <a-form-item name="remobile" class="ipt">
                <a-input v-model:value="formState.remobile" placeholder="请输入新手机号"> </a-input>
            </a-form-item> -->
            <a-form-item class="psd-wrap ipt" name="code">
                <a-input class="login-input" v-model:value="formState.code" placeholder="请输入验证码" style="height: 46px;">
                </a-input>
                <span :class="{ 'show-psd': true, code: true, disabled: !isEableSendCode }" @click="() => {
                    handleSendCodeClick(formState.mobile)
                }
                    " v-if="countDown === 60">
                    获取验证码
                </span>
                <span :class="{ 'show-psd': true, code: true }" v-else>
                    {{ countDown }}秒后重新获取
                </span>
            </a-form-item>
        </a-form>
    </a-modal>
</template>
<script lang="ts" setup>
import { ref, reactive, computed, onUnmounted, watch } from 'vue'
import { accountApi } from '@/api/account/index'
import { message } from 'ant-design-vue'
import { useUserInfoStore } from '@/stores/user-info'

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])
let confirmLoading = ref(false)
const formRef = ref()
const validateMobile = async (rule: any, value: string) => {
    if (value === '') {
        return Promise.reject('请输入新手机号码')
    }
    if (!/^1[0-9]{10}$/.test(value)) {
        return Promise.reject('请输入正确的手机号码')
    }
    return Promise.resolve()
}
const validateCode = async (rule: any, value: string) => {
    if (value === '') {
        return Promise.reject('请输入验证码')
    }
    if (!/^[0-9]{6}$/.test(value)) {
        return Promise.reject('请输入正确的验证码')
    }
    return Promise.resolve()
}
const rules = {
    mobile: [{ required: true, validator: validateMobile, trigger: 'change' }],
    remobile: [{ required: true, validator: validateMobile, trigger: 'change' }],
    code: [{ required: true, validator: validateCode, trigger: 'change' }]
}
const formState = reactive({
    mobile: '',
    remobile: '',
    code: ''
})
const LIMIT_TIMEOUT = 60
let timer: any = null
const countDown = ref(60)
// 是否可以发送验证码
const isEableSendCode = ref(false)
const setIsEableSendCode = () => {
    isEableSendCode.value = /^1[0-9]{10}$/.test(formState.mobile)
}
let visible = ref(false)
watch(formState, setIsEableSendCode, { deep: true })
watch(
    () => props.modelValue,
    () => {
        visible.value = props.modelValue
        if (!props.modelValue) {
            formState.mobile = ''
            formState.code = ''
            countDown.value = LIMIT_TIMEOUT
            formRef.value.resetFields()
        }
    },
    { immediate: true }
)
//发送验证码
const handleSendCodeClick = (mobile: string) => {
    if (!isEableSendCode.value) return
    // if (formState.mobile != formState.remobile) {
    //     message.error('两次输入的手机号不一致')
    //     return
    // }
    countDown.value = countDown.value - 1
    accountApi
        .getCode({ mobile })
        .then(() => {
            timer = setInterval(() => {
                countDown.value = countDown.value - 1
                if (countDown.value < 1) {
                    clearInterval(timer)
                    countDown.value = LIMIT_TIMEOUT
                }
            }, 1000)
        })
        .catch((err) => {
            message.error('发送失败！' + err.data?.message)
            countDown.value = LIMIT_TIMEOUT
        })
}

onUnmounted(() => {
    clearInterval(timer)
})
const userStore = useUserInfoStore()
const baseInfo = computed(() => userStore.userInfo)
const handleOk = () => {
    formRef.value.validate().then(() => {
        if (formState.mobile == baseInfo.value.mobile) {
            message.error('新手机号不能与原手机号相同')
            return
        }
        confirmLoading.value = true
        accountApi
            .modifyMobile({
                mobile: formState.mobile,
                code: formState.code,
                id: baseInfo.value.id
            })
            .then(() => {
                emit('update:modelValue', false)
                message.success('修改成功')
                confirmLoading.value = false
                userStore.initUserInfo()
            }).catch(() => {
                confirmLoading.value = false
            })
    })
}
const handleCancel = () => {
    emit('update:modelValue', false)
}
</script>
<style lang="less" scoped>
.psd-wrap {
    position: relative;

    .show-psd {
        z-index: 99;
        position: absolute;
        cursor: pointer;
        right: 16px;
        top: 13px;
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.5);
        font-size: 14px;

        &.code {
            color: #5b25fe;
        }

        &.disabled {
            color: rgba(91, 37, 254, 0.5);
        }
    }
}
</style>
